import { connect } from 'react-redux';
import SeeAllRecommendation from './see-all-recommendation';

const mapStateToProps = (state) =>  {
  return {
      
  };
}

export default connect(mapStateToProps, { })(SeeAllRecommendation);